import { createSlice } from '@reduxjs/toolkit';
import { getAllStaffMembers, getMentorById } from './staffService';

const initialState = {
  allStaffMembers: {
    isStaffMembersLoading: null,
    isStaffMembersSuccess: null,
    staffMembersMessage: null,
    pageCount: 0,
    staffMembers: [],
  },

  mentorDetails: {
    isMentorLoading: null,
    isMentorSuccess: null,
    mentorDetails: null
  },
};

const staffMembersSlice = createSlice({
  name: 'staffMember',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // PENDING
    builder
      .addCase(getAllStaffMembers.pending, (state) => {
        state.allStaffMembers = {
          ...initialState.allStaffMembers, // Reset to initial state
          isStaffMembersLoading: true,
          staffMembersMessage: 'Loading',
        };
      })

      // REJECTED
      .addCase(getAllStaffMembers.rejected, (state, action) => {
        state.allStaffMembers = {
          ...initialState.allStaffMembers,
          isStaffMembersLoading: false,
          isStaffMembersSuccess: false,
          staffMembersMessage: action.payload || 'Error occurred while fetching staffMembers',
        };
      })

      // FULFILLED
      .addCase(getAllStaffMembers.fulfilled, (state, action) => {
        state.allStaffMembers = {
          ...initialState.allStaffMembers,
          isStaffMembersLoading: false,
          isStaffMembersSuccess: true,
          pageCount: action.payload.pageCount || 0,
          staffMembers: action.payload.data || [],
        };
      });

    //Mentor Loading
    builder
      .addCase(getMentorById.pending, (state) => {
        state.mentorDetails = {
          ...initialState.mentorDetails, // Reset to initial state
          isMentorLoading: true,
        };
      })

      .addCase(getMentorById.rejected, (state, action) => {
        state.mentorDetails = {
          ...initialState.mentorDetails, // Reset to initial state
          isMentorLoading: false,
          isMentorSuccess: false,
        };
      })

      .addCase(getMentorById.fulfilled, (state, action) => {
        state.mentorDetails = {
          ...initialState.mentorDetails, // Reset to initial state
          isMentorLoading: false,
          isMentorSuccess: true,
          mentorDetails: action.payload || 'Successfully edited the staffMember.',
        };
      });
  },
});

export default staffMembersSlice.reducer;
